var map = {
	"./AI推荐词.svg": "AZcv",
	"./U+智投.svg": "lGeh",
	"./power.svg": "aUH0",
	"./公客列表.svg": "VDlw",
	"./列表.svg": "Vtmt",
	"./加盟管理.svg": "1mcK",
	"./客户统计.svg": "EmYk",
	"./开票管理.svg": "RCBi",
	"./招商经理管理.svg": "hwCK",
	"./数据中心.svg": "5g4I",
	"./无效列表.svg": "jYsE",
	"./权限管理.svg": "VUTz",
	"./直客列表.svg": "wqgt",
	"./私客列表.svg": "HhY2",
	"./财务管理.svg": "2Jxc",
	"./费效管理.svg": "dDTv",
	"./销售数据汇总.svg": "3wjd",
	"./黑名单列表.svg": "mY8l"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 28